import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function workQueueReducer(state = initialState.workQueue , action) {
    if (action.type === types.READ_WORKQUEUE_SUCCESS)
    {
        return action.workQueue;
    }
    else {
        return state;
    }
}
